import moment from "moment";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const defaultRender = (value) => (value ? value : "");
const formatDateTime = (dateTime) => {
    return moment(dateTime).format('DD-MM-YYYY HH:mm:ss');
};
const formatPrice = (value, decimalPlaces) => {
    if (value === null || value === undefined) return "";
    return Number(value)?.toFixed(decimalPlaces);
};


const useOrderCell = () => {
    const { t } = useTranslation();
    const decimalPlaces = useSelector((state) => state.user.decimalPlacesForAmountFormatting);
    const { symbols } = useSelector(state => state.watchlist)

    const getDigitsBySymbolId = (symbolId) => {
        return symbols?.[symbolId]?.digits;
    };
    return [
        { title: t("id"), dataIndex: 'ticket', render: defaultRender, },
        { title: t("time"), dataIndex: 'dateTime', render: formatDateTime, },
        { title: t('symbol'), dataIndex: 'symbolName', render: defaultRender, },
        { title: t('amount'), dataIndex: 'amount', render: (value) => formatPrice(value, decimalPlaces), },
        {
            title: t('type'), dataIndex: 'type', render: (type) => {
                switch (type) {
                    case 0: return t("new");
                    case 7: return t("BuyLimit");
                    case 8: return t("BuyStop");
                    case 6: return t("SellLimit");
                    case 9: return t("SellStop");
                    case 11: return t("SL/TP");
                    default: return type;
                }
            }
            ,
        },
        { title: 'B/S', dataIndex: 'side', render: defaultRender, },
        {
            title: t('openPrice'), dataIndex: 'openPrice', render: (value, row) => {
                const digits = getDigitsBySymbolId(row.symbolId);
                return value?.toFixed?.(digits);
            },
        },
        {
            title: t('s/l'), dataIndex: 'stopLoss', render: (value, row) => {
                const digits = getDigitsBySymbolId(row.symbolId);
                return value?.toFixed?.(digits);
            },
        },
        {
            title: t('t/p'), dataIndex: 'takeProfit', render: (value, row) => {
                const digits = getDigitsBySymbolId(row.symbolId);
                return value?.toFixed?.(digits);
            },
        },
        { title: t('openTicket'), dataIndex: 'openTicket', render: defaultRender, },
        { title: t("comment"), dataIndex: "comment", render: defaultRender },];
};

export default useOrderCell;
